// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as JsxPPXReactSupportU from "rescript/lib/es6/jsxPPXReactSupportU.js";
import * as Bank$OrcaPaymentPage from "../Bank.bs.js";
import * as Block$OrcaPaymentPage from "./Block.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as Country$OrcaPaymentPage from "../Country.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as Surcharge$OrcaPaymentPage from "./Surcharge.bs.js";
import * as GlobalVars$OrcaPaymentPage from "../GlobalVars.bs.js";
import * as DateOfBirth$OrcaPaymentPage from "../Payments/DateOfBirth.bs.js";
import * as InfoElement$OrcaPaymentPage from "./InfoElement.bs.js";
import * as PaymentType$OrcaPaymentPage from "../Types/PaymentType.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentField$OrcaPaymentPage from "./PaymentField.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "../Utilities/PaymentUtils.bs.js";
import * as DropdownField$OrcaPaymentPage from "./DropdownField.bs.js";
import * as RecoilAtomsV2$OrcaPaymentPage from "../Utilities/RecoilAtomsV2.bs.js";
import * as PaymentUtilsV2$OrcaPaymentPage from "../Utilities/PaymentUtilsV2.bs.js";
import * as PixPaymentInput$OrcaPaymentPage from "./PixPaymentInput.bs.js";
import * as GiftCardPinInput$OrcaPaymentPage from "./GiftCardPinInput.bs.js";
import * as UnifiedHelpersV2$OrcaPaymentPage from "../Utilities/UnifiedHelpersV2.bs.js";
import * as EmailPaymentInput$OrcaPaymentPage from "./EmailPaymentInput.bs.js";
import * as PaymentInputField$OrcaPaymentPage from "./PaymentInputField.bs.js";
import * as VpaIdPaymentInput$OrcaPaymentPage from "./VpaIdPaymentInput.bs.js";
import * as DynamicFieldsUtils$OrcaPaymentPage from "../Utilities/DynamicFieldsUtils.bs.js";
import * as PaymentTypeContext$OrcaPaymentPage from "../Context/PaymentTypeContext.bs.js";
import * as DocumentNumberInput$OrcaPaymentPage from "./DocumentNumberInput.bs.js";
import * as GiftCardNumberInput$OrcaPaymentPage from "./GiftCardNumberInput.bs.js";
import * as BlikCodePaymentInput$OrcaPaymentPage from "./BlikCodePaymentInput.bs.js";
import * as CountryStateDataRefs$OrcaPaymentPage from "../CountryStateDataRefs.bs.js";
import * as FullNamePaymentInput$OrcaPaymentPage from "./FullNamePaymentInput.bs.js";
import * as PaymentDropDownField$OrcaPaymentPage from "./PaymentDropDownField.bs.js";
import * as PaymentMethodsRecord$OrcaPaymentPage from "../Payments/PaymentMethodsRecord.bs.js";
import * as CryptoCurrencyNetworks$OrcaPaymentPage from "./CryptoCurrencyNetworks.bs.js";
import * as BillingNamePaymentInput$OrcaPaymentPage from "./BillingNamePaymentInput.bs.js";
import * as PhoneNumberPaymentInput$OrcaPaymentPage from "./PhoneNumberPaymentInput.bs.js";

function DynamicFields$DynamicFieldsToRenderWrapper(props) {
  var __isInside = props.isInside;
  var children = props.children;
  var isInside = __isInside !== undefined ? __isInside : true;
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: Caml_obj.notequal(children, null),
              children: React.createElement("div", {
                    key: (
                      isInside ? "inside" : "outside"
                    ) + "-billing-" + props.index.toString(),
                    className: "flex flex-col w-full place-content-between",
                    style: {
                      gridColumnGap: isInside ? "0px" : match.themeObj.spacingGridRow
                    }
                  }, children)
            });
}

var DynamicFieldsToRenderWrapper = {
  make: DynamicFields$DynamicFieldsToRenderWrapper
};

function DynamicFields(props) {
  var __isSplitPaymentsEnabled = props.isSplitPaymentsEnabled;
  var __isDisableInfoElement = props.isDisableInfoElement;
  var __isSaveDetailsWithClickToPay = props.isSaveDetailsWithClickToPay;
  var __cvcProps = props.cvcProps;
  var __expiryProps = props.expiryProps;
  var __cardProps = props.cardProps;
  var __savedMethod = props.savedMethod;
  var __isSavedCardFlow = props.isSavedCardFlow;
  var setRequiredFieldsBody = props.setRequiredFieldsBody;
  var paymentMethodType = props.paymentMethodType;
  var paymentMethod = props.paymentMethod;
  var isSavedCardFlow = __isSavedCardFlow !== undefined ? __isSavedCardFlow : false;
  var savedMethod = __savedMethod !== undefined ? __savedMethod : PaymentType$OrcaPaymentPage.defaultCustomerMethods;
  var cardProps = __cardProps !== undefined ? Caml_option.valFromOption(__cardProps) : undefined;
  var expiryProps = __expiryProps !== undefined ? Caml_option.valFromOption(__expiryProps) : undefined;
  var cvcProps = __cvcProps !== undefined ? Caml_option.valFromOption(__cvcProps) : undefined;
  var isSaveDetailsWithClickToPay = __isSaveDetailsWithClickToPay !== undefined ? __isSaveDetailsWithClickToPay : false;
  var isDisableInfoElement = __isDisableInfoElement !== undefined ? __isDisableInfoElement : false;
  var isSplitPaymentsEnabled = __isSplitPaymentsEnabled !== undefined ? __isSplitPaymentsEnabled : false;
  var paymentMethodListValue = Recoil.useRecoilValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  var paymentManagementListValue = Recoil.useRecoilValue(PaymentUtils$OrcaPaymentPage.paymentManagementListValue);
  var paymentMethodListValueV2 = Recoil.useRecoilValue(RecoilAtomsV2$OrcaPaymentPage.paymentMethodListValueV2);
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var themeObj = match.themeObj;
  var config = match.config;
  var contextPaymentType = PaymentTypeContext$OrcaPaymentPage.usePaymentType();
  var listValue;
  listValue = contextPaymentType === "PaymentMethodsManagement" ? paymentManagementListValue : paymentMethodListValueV2;
  React.useEffect((function () {
          setRequiredFieldsBody(function (param) {
                return {};
              });
        }), [paymentMethodType]);
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var billingAddress = match$1.billingAddress;
  var paymentMethodTypes = PaymentUtils$OrcaPaymentPage.usePaymentMethodTypeFromList(paymentMethodListValue, paymentMethod, paymentMethodType);
  var paymentMethodTypesV2 = PaymentUtilsV2$OrcaPaymentPage.usePaymentMethodTypeFromListV2(listValue, paymentMethod, paymentMethodType);
  var creditPaymentMethodTypes = PaymentUtils$OrcaPaymentPage.usePaymentMethodTypeFromList(paymentMethodListValue, paymentMethod, "credit");
  var creditPaymentMethodTypesV2 = PaymentUtilsV2$OrcaPaymentPage.usePaymentMethodTypeFromListV2(listValue, paymentMethod, "credit");
  var requiredFieldsWithBillingDetails = React.useMemo((function () {
          if (paymentMethod !== "card") {
            if (DynamicFieldsUtils$OrcaPaymentPage.dynamicFieldsEnabledPaymentMethods.includes(paymentMethodType)) {
              if (GlobalVars$OrcaPaymentPage.sdkVersion === "V1") {
                return paymentMethodTypes.required_fields;
              } else {
                return paymentMethodTypesV2.requiredFields;
              }
            } else {
              return [];
            }
          }
          if (GlobalVars$OrcaPaymentPage.sdkVersion === "V1") {
            var creditRequiredFields = creditPaymentMethodTypes.required_fields;
            return DynamicFieldsUtils$OrcaPaymentPage.removeRequiredFieldsDuplicates(Belt_Array.concatMany([
                            paymentMethodTypes.required_fields,
                            creditRequiredFields
                          ]));
          }
          var creditRequiredFields$1 = Core__Option.getOr(listValue.paymentMethodsEnabled.filter(function (item) {
                      if (item.paymentMethodSubtype === "credit") {
                        return item.paymentMethodType === "card";
                      } else {
                        return false;
                      }
                    })[0], UnifiedHelpersV2$OrcaPaymentPage.defaultPaymentMethods);
          var finalCreditRequiredFields = creditRequiredFields$1.requiredFields;
          return DynamicFieldsUtils$OrcaPaymentPage.removeRequiredFieldsDuplicates(Belt_Array.concatMany([
                          paymentMethodTypes.required_fields,
                          finalCreditRequiredFields
                        ]));
        }), [
        paymentMethod,
        paymentMethodTypes.required_fields,
        paymentMethodTypesV2.requiredFields,
        paymentMethodType,
        creditPaymentMethodTypes.required_fields,
        creditPaymentMethodTypesV2.requiredFields
      ]);
  var requiredFields = React.useMemo((function () {
          return DynamicFieldsUtils$OrcaPaymentPage.removeClickToPayFieldsIfSaveDetailsWithClickToPay(DynamicFieldsUtils$OrcaPaymentPage.removeBillingDetailsIfUseBillingAddress(requiredFieldsWithBillingDetails, billingAddress), isSaveDetailsWithClickToPay);
        }), [
        requiredFieldsWithBillingDetails,
        isSaveDetailsWithClickToPay
      ]);
  var isAllStoredCardsHaveName = React.useMemo((function () {
          return PaymentType$OrcaPaymentPage.getIsStoredPaymentMethodHasName(savedMethod);
        }), [savedMethod]);
  var clickToPayConfig = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.clickToPayConfig);
  var fieldsArr = React.useMemo((function () {
          return Belt_SortArray.stableSortBy(DynamicFieldsUtils$OrcaPaymentPage.updateDynamicFields(PaymentMethodsRecord$OrcaPaymentPage.getPaymentMethodFields(paymentMethodType, requiredFields, localeString, isSavedCardFlow, isAllStoredCardsHaveName), billingAddress, isSaveDetailsWithClickToPay, clickToPayConfig), PaymentMethodsRecord$OrcaPaymentPage.sortPaymentMethodFields);
        }), [
        requiredFields,
        isAllStoredCardsHaveName,
        isSavedCardFlow,
        isSaveDetailsWithClickToPay
      ]);
  var isSpacedInnerLayout = config.appearance.innerLayout === "Spaced";
  var match$2 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.userAddressline1);
  var setLine1 = match$2[1];
  var line1 = match$2[0];
  var match$3 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.userAddressline2);
  var setLine2 = match$3[1];
  var line2 = match$3[0];
  var match$4 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.userAddressCity);
  var setCity = match$4[1];
  var city = match$4[0];
  var match$5 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.userAddressState);
  var setState = match$5[1];
  var state = match$5[0];
  var match$6 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.userAddressPincode);
  var setPostalCode = match$6[1];
  var postalCode = match$6[0];
  var match$7 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.userCurrency);
  var setCurrency = match$7[1];
  var currency = match$7[0];
  var line1Ref = React.useRef(null);
  var line2Ref = React.useRef(null);
  var cityRef = React.useRef(null);
  var bankAccountNumberRef = React.useRef(null);
  var sourceBankAccountIdRef = React.useRef(null);
  var postalRef = React.useRef(null);
  var match$8 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.userBank);
  var setSelectedBank = match$8[1];
  var selectedBank = match$8[0];
  var match$9 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.userCountry);
  var setCountry = match$9[1];
  var country = match$9[0];
  var match$10 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.userBankAccountNumber);
  var setBankAccountNumber = match$10[1];
  var bankAccountNumber = match$10[0];
  var match$11 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.sourceBankAccountId);
  var setSourceBankAccountId = match$11[1];
  var sourceBankAccountId = match$11[0];
  var countryList = CountryStateDataRefs$OrcaPaymentPage.countryDataRef.contents;
  var stateNames = Utils$OrcaPaymentPage.getStateNames({
        value: country,
        errorString: ""
      });
  var bankNames;
  bankNames = GlobalVars$OrcaPaymentPage.sdkVersion === "V1" ? Utils$OrcaPaymentPage.getBankNames(Bank$OrcaPaymentPage.getBanks(paymentMethodType), paymentMethodTypes.bank_names) : Utils$OrcaPaymentPage.getBankNames(Bank$OrcaPaymentPage.getBanks(paymentMethodType), Core__Option.getOr(paymentMethodTypesV2.bankNames, []));
  var countryNames = Utils$OrcaPaymentPage.getCountryNames(Country$OrcaPaymentPage.getCountry(paymentMethodType, countryList));
  var setCurrency$1 = function (val) {
    setCurrency(val);
  };
  var setSelectedBank$1 = function (val) {
    setSelectedBank(val);
  };
  var setCountry$1 = function (val) {
    setCountry(val);
  };
  var defaultCardProps = CardUtils$OrcaPaymentPage.useDefaultCardProps();
  var defaultExpiryProps = CardUtils$OrcaPaymentPage.useDefaultExpiryProps();
  var defaultCvcProps = CardUtils$OrcaPaymentPage.useDefaultCvcProps();
  var cardProps$1 = cardProps !== undefined ? cardProps : defaultCardProps;
  var expiryProps$1 = expiryProps !== undefined ? expiryProps : defaultExpiryProps;
  var cvcProps$1 = cvcProps !== undefined ? cvcProps : defaultCvcProps;
  var cvcError = cvcProps$1.cvcError;
  var cvcRef = cvcProps$1.cvcRef;
  var handleCVCBlur = cvcProps$1.handleCVCBlur;
  var changeCVCNumber = cvcProps$1.changeCVCNumber;
  var cvcNumber = cvcProps$1.cvcNumber;
  var setIsCVCValid = cvcProps$1.setIsCVCValid;
  var isCVCValid = cvcProps$1.isCVCValid;
  var expiryError = expiryProps$1.expiryError;
  var expiryRef = expiryProps$1.expiryRef;
  var handleExpiryBlur = expiryProps$1.handleExpiryBlur;
  var changeCardExpiry = expiryProps$1.changeCardExpiry;
  var cardExpiry = expiryProps$1.cardExpiry;
  var setIsExpiryValid = expiryProps$1.setIsExpiryValid;
  var isExpiryValid = expiryProps$1.isExpiryValid;
  var maxCardLength = cardProps$1.maxCardLength;
  var cardError = cardProps$1.cardError;
  var icon = cardProps$1.icon;
  var cardRef = cardProps$1.cardRef;
  var handleCardBlur = cardProps$1.handleCardBlur;
  var changeCardNumber = cardProps$1.changeCardNumber;
  var cardNumber = cardProps$1.cardNumber;
  var setIsCardValid = cardProps$1.setIsCardValid;
  var isCardValid = cardProps$1.isCardValid;
  var isCvcValidValue = CardUtils$OrcaPaymentPage.getBoolOptionVal(isCVCValid);
  var match$12 = CardUtils$OrcaPaymentPage.useCardDetails(cvcNumber, isCvcValidValue, isCVCValid);
  var cardInvalid = match$12[2];
  var cardComplete = match$12[1];
  var cardEmpty = match$12[0];
  React.useEffect((function () {
          var bank = Core__Option.getOr(bankNames[0], "");
          setSelectedBank(function (param) {
                return bank;
              });
        }), []);
  var onPostalChange = function (ev) {
    var val = ev.target.value;
    if (val !== "") {
      return setPostalCode(function (param) {
                  return {
                          value: val,
                          isValid: true,
                          errorString: ""
                        };
                });
    } else {
      return setPostalCode(function (param) {
                  return {
                          value: val,
                          isValid: false,
                          errorString: ""
                        };
                });
    }
  };
  DynamicFieldsUtils$OrcaPaymentPage.useRequiredFieldsEmptyAndValid(requiredFields, fieldsArr, countryNames, bankNames, isCardValid, isExpiryValid, isCVCValid, cardNumber, cardExpiry, cvcNumber, isSavedCardFlow, isSplitPaymentsEnabled);
  DynamicFieldsUtils$OrcaPaymentPage.useSetInitialRequiredFields(billingAddress.usePrefilledValues === "Auto" ? requiredFieldsWithBillingDetails : requiredFields, paymentMethodType);
  DynamicFieldsUtils$OrcaPaymentPage.useRequiredFieldsBody(requiredFields, paymentMethodType, cardNumber, cardExpiry, cvcNumber, isSavedCardFlow, isAllStoredCardsHaveName, setRequiredFieldsBody);
  var submitCallback = DynamicFieldsUtils$OrcaPaymentPage.useSubmitCallback();
  Utils$OrcaPaymentPage.useSubmitPaymentData(submitCallback);
  var bottomElement = React.createElement(InfoElement$OrcaPaymentPage.make, {});
  var getCustomFieldName = function (item) {
    if (requiredFields.filter(function (requiredFieldType) {
            return requiredFieldType.field_type === item ? requiredFieldType.display_name === "card_holder_name" : false;
          }).length > 0) {
      return localeString.cardHolderName;
    }
    
  };
  var dynamicFieldsToRenderOutsideBilling = React.useMemo((function () {
          return fieldsArr.filter(DynamicFieldsUtils$OrcaPaymentPage.isFieldTypeToRenderOutsideBilling);
        }), [fieldsArr]);
  var dynamicFieldsToRenderInsideBilling = React.useMemo((function () {
          return fieldsArr.filter(function (field) {
                      return !DynamicFieldsUtils$OrcaPaymentPage.isFieldTypeToRenderOutsideBilling(field);
                    });
        }), [fieldsArr]);
  var isInfoElementPresent = dynamicFieldsToRenderOutsideBilling.includes("InfoElement");
  var isRenderInfoElement = isInfoElementPresent && !isDisableInfoElement;
  var isRenderDynamicFieldsInsideBilling = dynamicFieldsToRenderInsideBilling.length > 0;
  var spacedStylesForBiilingDetails = isSpacedInnerLayout ? "p-2" : "my-2";
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: !isSavedCardFlow && fieldsArr.length > 0,
              children: React.createElement(React.Fragment, {}, dynamicFieldsToRenderOutsideBilling.map(function (item, index) {
                        var tmp;
                        var exit = 0;
                        if (typeof item !== "object") {
                          switch (item) {
                            case "FullName" :
                                tmp = React.createElement(React.Fragment, {}, React.createElement(RenderIf$OrcaPaymentPage.make, {
                                          condition: !isSpacedInnerLayout,
                                          children: React.createElement("div", {
                                                style: {
                                                  fontSize: themeObj.fontSizeLg,
                                                  marginBottom: "5px",
                                                  opacity: "0.6"
                                                }
                                              }, Core__Option.getOr(getCustomFieldName(item), ""))
                                        }), React.createElement(FullNamePaymentInput$OrcaPaymentPage.make, {
                                          customFieldName: Caml_option.some(getCustomFieldName(item)),
                                          optionalRequiredFields: Caml_option.some(requiredFields)
                                        }));
                                break;
                            case "CardNumber" :
                                tmp = React.createElement(PaymentInputField$OrcaPaymentPage.make, {
                                      isValid: Caml_option.some(isCardValid),
                                      setIsValid: setIsCardValid,
                                      value: cardNumber,
                                      onChange: changeCardNumber,
                                      onBlur: handleCardBlur,
                                      rightIcon: Caml_option.some(icon),
                                      errorString: cardError,
                                      fieldName: localeString.cardNumberLabel,
                                      type_: "tel",
                                      maxLength: maxCardLength,
                                      placeholder: "1234 1234 1234 1234",
                                      inputRef: cardRef,
                                      autocomplete: "cc-number"
                                    });
                                break;
                            case "CardExpiryMonth" :
                            case "CardExpiryYear" :
                            case "CardExpiryMonthAndYear" :
                                exit = 1;
                                break;
                            case "CardCvc" :
                                tmp = React.createElement(PaymentInputField$OrcaPaymentPage.make, {
                                      isValid: Caml_option.some(isCVCValid),
                                      setIsValid: setIsCVCValid,
                                      value: cvcNumber,
                                      onChange: changeCVCNumber,
                                      onBlur: handleCVCBlur,
                                      rightIcon: Caml_option.some(CardUtils$OrcaPaymentPage.setRightIconForCvc(cardEmpty, cardInvalid, themeObj.colorIconCardCvcError, cardComplete)),
                                      errorString: cvcError,
                                      fieldName: localeString.cvcTextLabel,
                                      type_: "tel",
                                      maxLength: 4,
                                      placeholder: "123",
                                      className: "tracking-widest w-full",
                                      inputRef: cvcRef,
                                      autocomplete: "cc-csc"
                                    });
                                break;
                            case "CardExpiryAndCvc" :
                                tmp = React.createElement("div", {
                                      className: "flex gap-10"
                                    }, React.createElement(PaymentInputField$OrcaPaymentPage.make, {
                                          isValid: Caml_option.some(isExpiryValid),
                                          setIsValid: setIsExpiryValid,
                                          value: cardExpiry,
                                          onChange: changeCardExpiry,
                                          onBlur: handleExpiryBlur,
                                          errorString: expiryError,
                                          fieldName: localeString.validThruText,
                                          type_: "tel",
                                          maxLength: 7,
                                          placeholder: localeString.expiryPlaceholder,
                                          inputRef: expiryRef,
                                          autocomplete: "cc-exp"
                                        }), React.createElement(PaymentInputField$OrcaPaymentPage.make, {
                                          isValid: Caml_option.some(isCVCValid),
                                          setIsValid: setIsCVCValid,
                                          value: cvcNumber,
                                          onChange: changeCVCNumber,
                                          onBlur: handleCVCBlur,
                                          rightIcon: Caml_option.some(CardUtils$OrcaPaymentPage.setRightIconForCvc(cardEmpty, cardInvalid, themeObj.colorIconCardCvcError, cardComplete)),
                                          errorString: cvcError,
                                          fieldName: localeString.cvcTextLabel,
                                          type_: "tel",
                                          maxLength: 4,
                                          placeholder: "123",
                                          className: "tracking-widest w-full",
                                          inputRef: cvcRef,
                                          autocomplete: "cc-csc"
                                        }));
                                break;
                            case "CryptoCurrencyNetworks" :
                                tmp = React.createElement(CryptoCurrencyNetworks$OrcaPaymentPage.make, {});
                                break;
                            case "DateOfBirth" :
                                tmp = React.createElement(DateOfBirth$OrcaPaymentPage.make, {});
                                break;
                            case "VpaId" :
                                tmp = React.createElement(VpaIdPaymentInput$OrcaPaymentPage.make, {});
                                break;
                            case "PixKey" :
                                tmp = React.createElement(PixPaymentInput$OrcaPaymentPage.make, {
                                      fieldType: "pixKey"
                                    });
                                break;
                            case "PixCPF" :
                                tmp = React.createElement(PixPaymentInput$OrcaPaymentPage.make, {
                                      fieldType: "pixCPF"
                                    });
                                break;
                            case "PixCNPJ" :
                                tmp = React.createElement(PixPaymentInput$OrcaPaymentPage.make, {
                                      fieldType: "pixCNPJ"
                                    });
                                break;
                            case "BankAccountNumber" :
                            case "IBAN" :
                                exit = 2;
                                break;
                            case "SourceBankAccountId" :
                                tmp = React.createElement(PaymentField$OrcaPaymentPage.make, {
                                      setValue: setSourceBankAccountId,
                                      value: sourceBankAccountId,
                                      onChange: (function (ev) {
                                          var value = ev.target.value;
                                          setSourceBankAccountId(function (param) {
                                                return {
                                                        value: value,
                                                        isValid: value !== "",
                                                        errorString: value !== "" ? "" : localeString.sourceBankAccountIdEmptyText
                                                      };
                                              });
                                        }),
                                      onBlur: (function (ev) {
                                          var value = ev.target.value;
                                          setSourceBankAccountId(function (prev) {
                                                var newrecord = Caml_obj.obj_dup(prev);
                                                newrecord.isValid = value !== "";
                                                return newrecord;
                                              });
                                        }),
                                      fieldName: "Source Bank Account ID",
                                      name: "sourceBankAccountId",
                                      type_: "text",
                                      maxLength: 42,
                                      placeholder: "DE00 0000 0000 0000 0000 00",
                                      inputRef: sourceBankAccountIdRef
                                    });
                                break;
                            case "GiftCardNumber" :
                                tmp = React.createElement(GiftCardNumberInput$OrcaPaymentPage.make, {});
                                break;
                            case "GiftCardPin" :
                                tmp = React.createElement(GiftCardPinInput$OrcaPaymentPage.make, {});
                                break;
                            default:
                              tmp = null;
                          }
                        } else {
                          switch (item.TAG) {
                            case "Currency" :
                                var updatedCurrencyArray = DropdownField$OrcaPaymentPage.updateArrayOfStringToOptionsTypeArray(item._0);
                                tmp = React.createElement(DropdownField$OrcaPaymentPage.make, {
                                      appearance: config.appearance,
                                      value: currency,
                                      setValue: setCurrency$1,
                                      fieldName: localeString.currencyLabel,
                                      options: updatedCurrencyArray,
                                      disabled: false
                                    });
                                break;
                            case "DocumentType" :
                                var updatedDocumentTypeArray = DropdownField$OrcaPaymentPage.updateArrayOfStringToOptionsTypeArrayWithUpperCaseLabel(item._0);
                                tmp = React.createElement(DocumentNumberInput$OrcaPaymentPage.make, {
                                      options: updatedDocumentTypeArray
                                    });
                                break;
                            default:
                              tmp = null;
                          }
                        }
                        switch (exit) {
                          case 1 :
                              tmp = React.createElement(PaymentInputField$OrcaPaymentPage.make, {
                                    isValid: Caml_option.some(isExpiryValid),
                                    setIsValid: setIsExpiryValid,
                                    value: cardExpiry,
                                    onChange: changeCardExpiry,
                                    onBlur: handleExpiryBlur,
                                    errorString: expiryError,
                                    fieldName: localeString.validThruText,
                                    type_: "tel",
                                    maxLength: 7,
                                    placeholder: localeString.expiryPlaceholder,
                                    inputRef: expiryRef,
                                    autocomplete: "cc-exp"
                                  });
                              break;
                          case 2 :
                              tmp = React.createElement(PaymentField$OrcaPaymentPage.make, {
                                    setValue: setBankAccountNumber,
                                    value: bankAccountNumber,
                                    onChange: (function (ev) {
                                        var value = ev.target.value;
                                        setBankAccountNumber(function (param) {
                                              return {
                                                      value: value,
                                                      isValid: value !== "",
                                                      errorString: value !== "" ? "" : localeString.ibanEmptyText
                                                    };
                                            });
                                      }),
                                    onBlur: (function (ev) {
                                        var value = ev.target.value;
                                        setBankAccountNumber(function (prev) {
                                              var newrecord = Caml_obj.obj_dup(prev);
                                              newrecord.errorString = value !== "" ? "" : localeString.ibanEmptyText;
                                              newrecord.isValid = value !== "";
                                              return newrecord;
                                            });
                                      }),
                                    fieldName: "IBAN",
                                    name: "bankAccountNumber",
                                    type_: "text",
                                    maxLength: 42,
                                    placeholder: "DE00 0000 0000 0000 0000 00",
                                    inputRef: bankAccountNumberRef
                                  });
                              break;
                          
                        }
                        return JsxPPXReactSupportU.createElementWithKey(index.toString(), DynamicFields$DynamicFieldsToRenderWrapper, {
                                    children: tmp,
                                    index: index,
                                    isInside: false
                                  });
                      }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                        condition: isRenderDynamicFieldsInsideBilling,
                        children: React.createElement("div", {
                              className: "billing-section " + spacedStylesForBiilingDetails + " w-full text-left",
                              style: {
                                border: isSpacedInnerLayout ? "1px solid " + themeObj.borderColor : "",
                                borderRadius: isSpacedInnerLayout ? themeObj.borderRadius : ""
                              }
                            }, React.createElement("div", {
                                  className: "billing-details-text",
                                  style: {
                                    fontSize: themeObj.fontSizeLg,
                                    marginBottom: "5px",
                                    opacity: "0.6"
                                  }
                                }, localeString.billingDetailsText), React.createElement("div", {
                                  className: "flex flex-col",
                                  style: {
                                    gap: isSpacedInnerLayout ? themeObj.spacingGridRow : ""
                                  }
                                }, dynamicFieldsToRenderInsideBilling.map(function (item, index) {
                                      var tmp;
                                      if (typeof item !== "object") {
                                        switch (item) {
                                          case "Email" :
                                              tmp = React.createElement(EmailPaymentInput$OrcaPaymentPage.make, {});
                                              break;
                                          case "Country" :
                                              var updatedCountryNames = DropdownField$OrcaPaymentPage.updateArrayOfStringToOptionsTypeArray(countryNames);
                                              tmp = React.createElement(DropdownField$OrcaPaymentPage.make, {
                                                    appearance: config.appearance,
                                                    value: country,
                                                    setValue: setCountry$1,
                                                    fieldName: localeString.countryLabel,
                                                    options: updatedCountryNames,
                                                    disabled: false
                                                  });
                                              break;
                                          case "Bank" :
                                              var updatedBankNames = DropdownField$OrcaPaymentPage.updateArrayOfStringToOptionsTypeArray(bankNames);
                                              tmp = React.createElement(DropdownField$OrcaPaymentPage.make, {
                                                    appearance: config.appearance,
                                                    value: selectedBank,
                                                    setValue: setSelectedBank$1,
                                                    fieldName: localeString.bankLabel,
                                                    options: updatedBankNames,
                                                    disabled: false
                                                  });
                                              break;
                                          case "BillingName" :
                                              tmp = React.createElement(BillingNamePaymentInput$OrcaPaymentPage.make, {
                                                    requiredFields: requiredFields
                                                  });
                                              break;
                                          case "PhoneNumberAndCountryCode" :
                                              tmp = React.createElement(PhoneNumberPaymentInput$OrcaPaymentPage.make, {});
                                              break;
                                          case "AddressLine1" :
                                              tmp = React.createElement(PaymentField$OrcaPaymentPage.make, {
                                                    setValue: setLine1,
                                                    value: line1,
                                                    onChange: (function (ev) {
                                                        var value = ev.target.value;
                                                        setLine1(function (prev) {
                                                              return {
                                                                      value: value,
                                                                      isValid: value !== "",
                                                                      errorString: value !== "" ? "" : prev.errorString
                                                                    };
                                                            });
                                                      }),
                                                    onBlur: (function (ev) {
                                                        var value = ev.target.value;
                                                        setLine1(function (prev) {
                                                              var newrecord = Caml_obj.obj_dup(prev);
                                                              newrecord.isValid = value !== "";
                                                              return newrecord;
                                                            });
                                                      }),
                                                    fieldName: localeString.line1Label,
                                                    name: "line1",
                                                    type_: "text",
                                                    placeholder: localeString.line1Placeholder,
                                                    className: isSpacedInnerLayout ? "" : "!border-b-0",
                                                    inputRef: line1Ref
                                                  });
                                              break;
                                          case "AddressLine2" :
                                              tmp = React.createElement(PaymentField$OrcaPaymentPage.make, {
                                                    setValue: setLine2,
                                                    value: line2,
                                                    onChange: (function (ev) {
                                                        var value = ev.target.value;
                                                        setLine2(function (prev) {
                                                              return {
                                                                      value: value,
                                                                      isValid: value !== "",
                                                                      errorString: value !== "" ? "" : prev.errorString
                                                                    };
                                                            });
                                                      }),
                                                    onBlur: (function (ev) {
                                                        var value = ev.target.value;
                                                        setLine2(function (prev) {
                                                              var newrecord = Caml_obj.obj_dup(prev);
                                                              newrecord.isValid = value !== "";
                                                              return newrecord;
                                                            });
                                                      }),
                                                    fieldName: localeString.line2Label,
                                                    name: "line2",
                                                    type_: "text",
                                                    placeholder: localeString.line2Placeholder,
                                                    inputRef: line2Ref
                                                  });
                                              break;
                                          case "AddressCity" :
                                              tmp = React.createElement(PaymentField$OrcaPaymentPage.make, {
                                                    setValue: setCity,
                                                    value: city,
                                                    onChange: (function (ev) {
                                                        var value = ev.target.value;
                                                        setCity(function (prev) {
                                                              return {
                                                                      value: value,
                                                                      isValid: value !== "",
                                                                      errorString: value !== "" ? "" : prev.errorString
                                                                    };
                                                            });
                                                      }),
                                                    onBlur: (function (ev) {
                                                        var value = ev.target.value;
                                                        setCity(function (prev) {
                                                              var newrecord = Caml_obj.obj_dup(prev);
                                                              newrecord.isValid = value !== "";
                                                              return newrecord;
                                                            });
                                                      }),
                                                    fieldName: localeString.cityLabel,
                                                    name: "city",
                                                    type_: "text",
                                                    placeholder: localeString.cityLabel,
                                                    inputRef: cityRef
                                                  });
                                              break;
                                          case "StateAndCity" :
                                              tmp = React.createElement("div", {
                                                    className: "flex " + (
                                                      isSpacedInnerLayout ? "gap-4" : ""
                                                    ) + " overflow-hidden"
                                                  }, React.createElement(PaymentField$OrcaPaymentPage.make, {
                                                        setValue: setCity,
                                                        value: city,
                                                        onChange: (function (ev) {
                                                            var value = ev.target.value;
                                                            setCity(function (prev) {
                                                                  return {
                                                                          value: value,
                                                                          isValid: value !== "",
                                                                          errorString: value !== "" ? "" : prev.errorString
                                                                        };
                                                                });
                                                          }),
                                                        onBlur: (function (ev) {
                                                            var value = ev.target.value;
                                                            setCity(function (prev) {
                                                                  var newrecord = Caml_obj.obj_dup(prev);
                                                                  newrecord.isValid = value !== "";
                                                                  return newrecord;
                                                                });
                                                          }),
                                                        fieldName: localeString.cityLabel,
                                                        name: "city",
                                                        type_: "text",
                                                        placeholder: localeString.cityLabel,
                                                        className: isSpacedInnerLayout ? "" : "!border-r-0",
                                                        inputRef: cityRef
                                                      }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                                                        condition: stateNames.length > 0,
                                                        children: React.createElement(PaymentDropDownField$OrcaPaymentPage.make, {
                                                              value: state,
                                                              setValue: setState,
                                                              fieldName: localeString.stateLabel,
                                                              options: stateNames
                                                            })
                                                      }));
                                              break;
                                          case "AddressPincode" :
                                              tmp = React.createElement(PaymentField$OrcaPaymentPage.make, {
                                                    setValue: setPostalCode,
                                                    value: postalCode,
                                                    onChange: onPostalChange,
                                                    onBlur: (function (ev) {
                                                        var value = ev.target.value;
                                                        setPostalCode(function (prev) {
                                                              var newrecord = Caml_obj.obj_dup(prev);
                                                              newrecord.isValid = value !== "";
                                                              return newrecord;
                                                            });
                                                      }),
                                                    fieldName: localeString.postalCodeLabel,
                                                    name: "postal",
                                                    placeholder: localeString.postalCodeLabel,
                                                    inputRef: postalRef
                                                  });
                                              break;
                                          case "AddressState" :
                                              tmp = React.createElement(RenderIf$OrcaPaymentPage.make, {
                                                    condition: stateNames.length > 0,
                                                    children: React.createElement(PaymentDropDownField$OrcaPaymentPage.make, {
                                                          value: state,
                                                          setValue: setState,
                                                          fieldName: localeString.stateLabel,
                                                          options: stateNames
                                                        })
                                                  });
                                              break;
                                          case "BlikCode" :
                                              tmp = React.createElement(BlikCodePaymentInput$OrcaPaymentPage.make, {});
                                              break;
                                          default:
                                            tmp = null;
                                        }
                                      } else {
                                        switch (item.TAG) {
                                          case "BankList" :
                                              var updatedBankNames$1 = DropdownField$OrcaPaymentPage.updateArrayOfStringToOptionsTypeArray(Utils$OrcaPaymentPage.getBankNames(Bank$OrcaPaymentPage.getBanks(paymentMethodType), item._0));
                                              tmp = React.createElement(DropdownField$OrcaPaymentPage.make, {
                                                    appearance: config.appearance,
                                                    value: selectedBank,
                                                    setValue: setSelectedBank$1,
                                                    fieldName: localeString.bankLabel,
                                                    options: updatedBankNames$1,
                                                    disabled: false
                                                  });
                                              break;
                                          case "SpecialField" :
                                              tmp = item._0;
                                              break;
                                          case "CountryAndPincode" :
                                              var updatedCountryArray = DropdownField$OrcaPaymentPage.updateArrayOfStringToOptionsTypeArray(item._0);
                                              tmp = React.createElement("div", {
                                                    className: "flex " + (
                                                      isSpacedInnerLayout ? "gap-4" : ""
                                                    )
                                                  }, React.createElement(DropdownField$OrcaPaymentPage.make, {
                                                        appearance: config.appearance,
                                                        value: country,
                                                        setValue: setCountry$1,
                                                        fieldName: localeString.countryLabel,
                                                        options: updatedCountryArray,
                                                        disabled: false,
                                                        className: isSpacedInnerLayout ? "" : "!border-t-0 !border-r-0"
                                                      }), React.createElement(PaymentField$OrcaPaymentPage.make, {
                                                        setValue: setPostalCode,
                                                        value: postalCode,
                                                        onChange: onPostalChange,
                                                        onBlur: (function (ev) {
                                                            var value = ev.target.value;
                                                            setPostalCode(function (prev) {
                                                                  var newrecord = Caml_obj.obj_dup(prev);
                                                                  newrecord.isValid = value !== "";
                                                                  return newrecord;
                                                                });
                                                          }),
                                                        fieldName: localeString.postalCodeLabel,
                                                        name: "postal",
                                                        placeholder: localeString.postalCodeLabel,
                                                        className: isSpacedInnerLayout ? "" : "!border-t-0",
                                                        inputRef: postalRef
                                                      }));
                                              break;
                                          case "AddressCountry" :
                                              var updatedCountryArr = DropdownField$OrcaPaymentPage.updateArrayOfStringToOptionsTypeArray(item._0);
                                              tmp = React.createElement(DropdownField$OrcaPaymentPage.make, {
                                                    appearance: config.appearance,
                                                    value: country,
                                                    setValue: setCountry$1,
                                                    fieldName: localeString.countryLabel,
                                                    options: updatedCountryArr,
                                                    disabled: false
                                                  });
                                              break;
                                          default:
                                            tmp = null;
                                        }
                                      }
                                      return JsxPPXReactSupportU.createElementWithKey(index.toString(), DynamicFields$DynamicFieldsToRenderWrapper, {
                                                  children: tmp,
                                                  index: index
                                                });
                                    })))
                      }), React.createElement(Surcharge$OrcaPaymentPage.make, {
                        paymentMethod: paymentMethod,
                        paymentMethodType: paymentMethodType
                      }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                        condition: isRenderInfoElement,
                        children: React.createElement(React.Fragment, {
                              children: Caml_option.some(fieldsArr.length > 1 ? bottomElement : React.createElement(Block$OrcaPaymentPage.make, {
                                          bottomElement: Caml_option.some(bottomElement)
                                        }))
                            })
                      }))
            });
}

var make = DynamicFields;

export {
  DynamicFieldsToRenderWrapper ,
  make ,
}
/* react Not a pure module */
